// extracted by mini-css-extract-plugin
export var artArchiveStyle = "FeaturedMediaDefault-module--art-archive-style--RC9VK";
export var defaultStyle = "FeaturedMediaDefault-module--default-style--eFjUT";
export var featuredMediaImage = "FeaturedMediaDefault-module--featured-media-image--UgzWd";
export var homeStyle = "FeaturedMediaDefault-module--home-style--0qKcK";
export var image = "FeaturedMediaDefault-module--image--Z43wB";